import React from "react";
import SendEmail from "../../components/members/SendEmail";

// import { Container } from './styles';

const SendEmailPage: React.FC = () => {
  return (
    <>
      <SendEmail />
    </>
  );
};

export default SendEmailPage;
